import type {MVTFeature} from '@/services/MapService/MVTLayers/types';
import {Feature} from '@/services/OverlaysService';

export type LegendFeature = MVTFeature | Feature;
export interface ILegendItem {
  fillColor: string;
  strokeColor: string;
  label: string;
  visible: boolean;
  image?: HTMLImageElement | null;
  imageOpts?: {
    width: number;
    height: number;
    offsetX: number;
    offsetY: number;
  } | null;
  matcherFn: (feature: MVTFeature | Feature) => boolean;
}

/** Represents a legend item in a legend group and its visibility in the layer menu and on the map. */
export class LegendItem implements ILegendItem {
  uid: string;
  fillColor: string;
  strokeColor: string;
  label: string;
  visible: boolean;
  image?: HTMLImageElement | null;
  imageOpts?: {
    width: number;
    height: number;
    offsetX: number;
    offsetY: number;
  } | null;

  // Optional function to match the legend item with a feature.
  matcherFn: (feature: LegendFeature) => boolean;

  constructor({
    fillColor,
    strokeColor,
    label,
    visible = true,
    image,
    imageOpts,
    matcherFn,
  }: ILegendItem) {
    this.uid = Math.random().toString(36).substring(2, 15);
    this.fillColor = fillColor;
    this.strokeColor = strokeColor;
    this.label = label;
    this.visible = visible;
    this.image = image || null;
    this.imageOpts = imageOpts || null;
    this.matcherFn = matcherFn;
  }

  matches(feature: LegendFeature): boolean {
    return this.visible && this.matcherFn(feature);
  }
}
